import React, { useEffect } from 'react'
import './filterbutton.scss'
import { connect } from 'react-redux'
import { huntPlannerActiveOtions } from '../../../../action/huntplanner-selected-options'
import { huntplannerMorefilters } from '../../../../action/huntplanner-morefilters-actions'


const Filterbutton = (props) => {

  let removeFilterOption = (header, value) => {
    let selectedOption = { ...props.huntPlannerSelectedOtions }; // Clone to avoid mutating props
    let morefiltersState = { ...props.huntplannerMorefiltersState }; // Clone to avoid direct mutation

    // Update the matching key with an empty string
    if (morefiltersState.hasOwnProperty(header)) {
      morefiltersState[header] = "";
    }

    // Remove the matching key from selectedOption
    if (selectedOption.hasOwnProperty(header)) {
      delete selectedOption[header];
    }
    props.huntPlannerActiveOtions(selectedOption)  // undefined should also remove
    props.huntplannerMorefilters(morefiltersState)
  }

  const formatLabel = (value) => {
    if (value === "trophyPotential") return "Trophy Potentials";
    return value.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
  };

  return (
    <div className='filterbutton-container'>
      <div className='filterbutton-text-style'>
        <p className='p-text-ft-btn' style={{}}>  {typeof props.value === 'number' || !isNaN(props.value) ? formatLabel(props.header) : props.value}</p>
        {!props.huntPlannerUnitRightMenuBar?.expanded && <p className='' style={{ cursor: 'pointer', width: '10%' }} onClick={() => { removeFilterOption(props.header, props.value) }}>X</p>}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  huntplannerStatesData: state.huntplannerStatesData,
  huntplannerMorefiltersState: state.huntplannerMorefilters,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntPlannerFilterOptions: state.huntPlannerFilterOptions,
  huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,

})

const mapDispatchToProps = dispatch => ({
  huntplannerMorefilters: (payload) => dispatch(huntplannerMorefilters(payload)),
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(Filterbutton)
